import * as React from "react";
import { VBox, HBox } from "framework/structural_components/hbox_vbox";
import { LoadingSpinner, LoadingError } from "framework/controls/loading";
import { useUIContext } from "common/uicontext/store";
import { useCompetitioIndexesCompAge } from "../../../competitions/indexes/compAgeStore";
import { useCompetitioIndexesCompClass } from "../../../competitions/indexes/compClassStore";
import { useCompetitioIndexesCompCompetitor } from "../../../competitions/indexes/compCompetitorStore";
import { useCompetitioIndexesCompDiscipline } from "../../../competitions/indexes/compDisciplineStore";
import { useCompetitioIndexesCompType } from "../../../competitions/indexes/compTypeStore";
import { useCompetitioIndexesCompSeries } from "../../../competitions/indexes/compSeriesStore";
import { useCountries } from "../../../countries/store";
import { CompetitorType, EventType } from "../../entity";
import { attendeeItemNewCouple, attendeeItemNewDuo, attendeeItemNewDuoCZE, attendeeItemNewFemale, attendeeItemNewGroup, attendeeItemNewFormation, attendeeItemNewTeam, attendeeItemNewMale, useCompetitionRegistration } from "./store";
import { CompetitionsView } from "./competitions/view";
import { NewAttendeeView } from "./new_attendee/view";
import { cls_form_area_box } from "style/form.css";
import { cls_display_none, cls_gap_form, cls_gap_rem, cls_wrap } from "style/index.css";
import { cls_align_items_stretch } from "framework/structural_components/hbox_vbox.css";
import { cls_searchselect_box, cls_searchselect_box_teams } from "./view.css";
import { SearchSelect, SearchSelectItem } from "framework/controls/searchSelect";
import { useif } from "framework/state/types";
import { LoginButton } from "common/login_dialog/login_dialog";
import { useEventCalendarCompetitions } from "../competitions/store";
import { Checkbox } from "framework/controls/checkbox";
import { cls_label } from "framework/controls/label.css";
var Content = function () {
    var _a;
    var _b = useCompetitionRegistration(), state = _b[0], actions = _b[1];
    var _c = useCompetitionRegistration(), _d = _c[0], attendees = _d.attendees, filteredAttendees = _d.filteredAttendees, selectedAttendee = _d.selectedAttendee, filter = _d.filter, _e = _c[1], selectAttendee = _e.selectAttendee, setAvailableAttendees = _e.setAvailableAttendees, setFilter = _e.setFilter, setFilteredAttendees = _e.setFilteredAttendees;
    var uiContextState = useUIContext()[0];
    var eventRegistration = (_a = uiContextState.data) === null || _a === void 0 ? void 0 : _a.event_registration;
    var collection = useEventCalendarCompetitions()[0].collection;
    var anyCoupleCompetition = collection.findIndex(function (c) { return c.competitorId === CompetitorType.Couple; }) >= 0;
    var anyDuoCompetition = collection.findIndex(function (c) { return c.competitorId === CompetitorType.Duo; }) >= 0;
    var anySoloDancerCompetition = collection.findIndex(function (c) { return c.competitorId === CompetitorType.SoloDancer; }) >= 0;
    var anyGroupCompetition = collection.findIndex(function (c) { return c.competitorId === CompetitorType.Group || c.competitorId === CompetitorType.SmallTeam || c.competitorId === CompetitorType.BigTeam; }) >= 0;
    var anyFormationCompetition = collection.findIndex(function (c) { return c.competitorId === CompetitorType.Formation; }) >= 0;
    var anyTeamCompetition = collection.findIndex(function (c) { return c.competitorId === CompetitorType.Team; }) >= 0;
    React.useEffect(function () {
        if (eventRegistration) {
            setAvailableAttendees(eventRegistration.attendees);
        }
    }, [eventRegistration]);
    React.useEffect(function () {
        var filtered = [];
        if (filter) {
            filtered = attendees.filter(function (x) { return x.key[0] != '*'; }).filter(function (x) { var _a; return (_a = x.name) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase().includes(filter.trim().toLocaleLowerCase()); });
        }
        else {
            filtered = attendees.filter(function (x) { return x.key[0] != '*'; });
        }
        filtered = filtered.filter(function (x) { return x.type === state.competitorTypeToRegister; });
        if (filtered.length > 10) {
            var cutoff = filtered.length - 10;
            filtered = filtered.slice(0, 10);
            filtered.push({ key: '-', name: "...a další" + (cutoff >= 5 ? "ch" : "") + " " + cutoff, type: null, isNew: false });
        }
        if (state.competitorTypeToRegister === CompetitorType.Couple) {
            filtered.push(attendeeItemNewCouple);
        }
        if (state.competitorTypeToRegister === CompetitorType.SoloDancer) {
            filtered.push(attendeeItemNewFemale);
            filtered.push(attendeeItemNewMale);
        }
        if (state.competitorTypeToRegister === CompetitorType.Duo) {
            filtered.push(attendeeItemNewDuo);
            filtered.push(attendeeItemNewDuoCZE);
        }
        if (state.competitorTypeToRegister === CompetitorType.Group) {
            filtered.push(attendeeItemNewGroup);
        }
        if (state.competitorTypeToRegister === CompetitorType.Formation) {
            filtered.push(attendeeItemNewFormation);
        }
        if (state.competitorTypeToRegister === CompetitorType.Team) {
            filtered.push(attendeeItemNewTeam);
        }
        setFilteredAttendees(filtered);
    }, [filter, attendees, state.competitorTypeToRegister]);
    var getSelItem = function (v) {
        return v == '' ? "Zvolte..." : attendees.find(function (x) { return x.key == v; }).name;
    };
    var competitorType = state.competitorTypeToRegister;
    var showSearchSelect = competitorType !== null;
    var CompetitorNaming = function (val) {
        if (val === CompetitorType.Couple || val === CompetitorType.ProAm) {
            return "pár";
        }
        if (val === CompetitorType.Duo) {
            return "duo";
        }
        if (val === CompetitorType.SoloDancer) {
            return "jednotlivce";
        }
        if (val === CompetitorType.Group) {
            return "skupinu";
        }
        if (val === CompetitorType.Formation) {
            return "formaci";
        }
        if (val === CompetitorType.Team) {
            return "družstvo";
        }
        return "soutěžící";
    };
    var competitorTypes = [
        CompetitorType.Couple,
        CompetitorType.Duo,
        CompetitorType.Formation,
        CompetitorType.Group,
        CompetitorType.SmallTeam,
        CompetitorType.BigTeam,
        CompetitorType.ProAm,
        CompetitorType.SoloDancer,
        CompetitorType.Team,
    ].filter(function (ct) { return collection.findIndex(function (c) { return c.competitorId === ct; }) >= 0; });
    var onlyOneCompetitorType = competitorTypes.length === 1
        ? ((competitorTypes[0] === CompetitorType.SmallTeam || competitorTypes[0] === CompetitorType.BigTeam)
            ? CompetitorType.Group
            : competitorTypes[0])
        : null;
    React.useEffect(function () {
        if (competitorType !== onlyOneCompetitorType && onlyOneCompetitorType !== null) {
            actions.setCompetitorTypeToRegister(onlyOneCompetitorType);
        }
    }, [onlyOneCompetitorType, competitorType]);
    var clsForSearchSelectBox = competitorType === CompetitorType.Team ? cls_searchselect_box_teams : cls_searchselect_box;
    return React.createElement(VBox, { className: [cls_gap_form, cls_form_area_box] },
        onlyOneCompetitorType === null && React.createElement(VBox, null,
            React.createElement(HBox, { className: cls_label }, "P\u0159eji si p\u0159\u00EDhl\u00E1sit:"),
            React.createElement(HBox, { className: [cls_gap_rem, cls_wrap] },
                anyCoupleCompetition && React.createElement(Checkbox, { label: "P\u00E1r", getter: function () { return competitorType === CompetitorType.Couple; }, setter: function () { return actions.setCompetitorTypeToRegister(CompetitorType.Couple); } }),
                anyDuoCompetition && React.createElement(Checkbox, { label: "Duo", getter: function () { return competitorType === CompetitorType.Duo; }, setter: function () { return actions.setCompetitorTypeToRegister(CompetitorType.Duo); } }),
                anySoloDancerCompetition && React.createElement(Checkbox, { label: "Jednotlivce", getter: function () { return competitorType === CompetitorType.SoloDancer; }, setter: function () { return actions.setCompetitorTypeToRegister(CompetitorType.SoloDancer); } }),
                anyGroupCompetition && React.createElement(Checkbox, { label: "Skupinu", getter: function () { return competitorType === CompetitorType.Group; }, setter: function () { return actions.setCompetitorTypeToRegister(CompetitorType.Group); } }),
                anyFormationCompetition && React.createElement(Checkbox, { label: "Formaci", getter: function () { return competitorType === CompetitorType.Formation; }, setter: function () { return actions.setCompetitorTypeToRegister(CompetitorType.Formation); } }),
                anyTeamCompetition && React.createElement(Checkbox, { label: "Formaci", getter: function () { return competitorType === CompetitorType.Team; }, setter: function () { return actions.setCompetitorTypeToRegister(CompetitorType.Team); } }))),
        showSearchSelect && React.createElement(HBox, null,
            React.createElement(VBox, { className: [clsForSearchSelectBox, cls_align_items_stretch] },
                React.createElement(SearchSelect, { name: null, label: "Vyberte ".concat(CompetitorNaming(competitorType), " k p\u0159ihl\u00E1\u0161en\u00ED:"), onFilter: setFilter, selectedValue: (selectedAttendee === null || selectedAttendee === void 0 ? void 0 : selectedAttendee.key) || '', onSelect: selectAttendee, keyToTextMapFunc: getSelItem }, filteredAttendees.map(function (a) { return React.createElement(SearchSelectItem, { key: a.key, keyValue: a.key.toString(), children: a.name }); })))),
        React.createElement(NewAttendeeView, null),
        React.createElement(CompetitionsView, null));
};
var View = function (props) {
    var _a;
    var _b = useCompetitionRegistration(), state = _b[0], actions = _b[1];
    var _c = useUIContext(), uiContextState = _c[0], loadEventRegistrationUIContext = _c[1].loadEventRegistrationUIContext;
    var _d = useCountries(), countriesState = _d[0], loadCountries = _d[1].loadCountries;
    var _e = useEventCalendarCompetitions(), _f = _e[1], loadCompetitions = _f.loadCompetitions, invalidate = _f.invalidate;
    var _g = useCompetitioIndexesCompSeries(), compSeriesState = _g[0], loadCompSeries = _g[1].loadCompSeries;
    var _h = useCompetitioIndexesCompType(), compTypeState = _h[0], loadCompTypes = _h[1].loadCompTypes;
    var _j = useCompetitioIndexesCompCompetitor(), compCompetitorState = _j[0], loadCompCompetitors = _j[1].loadCompCompetitors;
    var _k = useCompetitioIndexesCompAge(), compAgeState = _k[0], loadCompAges = _k[1].loadCompAges;
    var _l = useCompetitioIndexesCompClass(), compClassState = _l[0], loadCompClasses = _l[1].loadCompClasses;
    var _m = useCompetitioIndexesCompDiscipline(), compDisciplineState = _m[0], loadCompDisciplines = _m[1].loadCompDisciplines;
    React.useEffect(function () {
        invalidate();
        loadCompetitions(props.eventId, props.eventCompetitionId, "type");
        loadCountries();
        loadCompAges();
        loadCompClasses();
        loadCompCompetitors();
        loadCompDisciplines();
        loadCompTypes();
        loadCompSeries();
        actions.setCompetitorTypeToRegister(null);
    }, []);
    React.useEffect(function () {
        actions.reset(props.eventId, props.eventCompetitionId); // reset store !!!
        if (uiContextState.data.logged_user) {
            loadEventRegistrationUIContext(EventType.Competition, props.eventCompetitionId);
        }
    }, [props.eventCompetitionId, props.eventId, (_a = uiContextState.data.logged_user) === null || _a === void 0 ? void 0 : _a.email]);
    React.useEffect(function () {
        if (state.needToReloadAvailableCompetitors) {
            actions.setNeedToReloadAvailableCompetitorsFalse();
            loadEventRegistrationUIContext(EventType.Competition, props.eventCompetitionId);
        }
    }, [state.needToReloadAvailableCompetitors]);
    var loadingTooLong = false //uiContextState.loadingTooLong
        || countriesState.loadingTooLong
        || compAgeState.loadingTooLong
        || compClassState.loadingTooLong
        || compCompetitorState.loadingTooLong
        || compDisciplineState.loadingTooLong
        || compTypeState.loadingTooLong
        || compSeriesState.loadingTooLong;
    var loading = false //uiContextState.loading
        || countriesState.loading
        || compAgeState.loading
        || compClassState.loading
        || compCompetitorState.loading
        || compDisciplineState.loading
        || compTypeState.loading
        || compSeriesState.loading;
    var loadFailure = uiContextState.loadFailure
        || countriesState.loadFailure
        || compAgeState.loadFailure
        || compClassState.loadFailure
        || compCompetitorState.loadFailure
        || compDisciplineState.loadFailure
        || compTypeState.loadFailure
        || compSeriesState.loadFailure;
    var showContent = !loading && !loadFailure;
    var registration_content = React.createElement(VBox, null,
        loadingTooLong && React.createElement(LoadingSpinner, null),
        loadFailure && React.createElement(LoadingError, null),
        showContent && React.createElement(Content, null));
    var uicontext_state = useUIContext()[0];
    var LU = !!uicontext_state.data.logged_user;
    return React.createElement(React.Fragment, null,
        React.createElement(VBox, { className: useif(!LU, cls_display_none) }, registration_content),
        !LU ? React.createElement(VBox, { className: cls_gap_form },
            React.createElement(HBox, null, "Pro p\u0159ihl\u00E1\u0161en\u00ED na sout\u011B\u017E se mus\u00EDte p\u0159ihl\u00E1sit do syst\u00E9mu."),
            React.createElement(HBox, null,
                React.createElement(LoginButton, { disableMobileVersionStyle: true }))) : React.createElement(React.Fragment, null));
};
export { View as CompetitionRegistration, };
